var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8246 8.81731C15.251 7.0609 17.749 7.0609 18.1754 8.81731C18.4508 9.95193 19.7507 10.4904 20.7478 9.88285C22.2913 8.94239 24.0576 10.7087 23.1172 12.2522C22.5096 13.2493 23.0481 14.5492 24.1827 14.8246C25.9391 15.251 25.9391 17.749 24.1827 18.1754C23.0481 18.4508 22.5096 19.7507 23.1172 20.7478C24.0576 22.2913 22.2913 24.0576 20.7478 23.1172C19.7507 22.5096 18.4508 23.0481 18.1754 24.1827C17.749 25.9391 15.251 25.9391 14.8246 24.1827C14.5492 23.0481 13.2493 22.5096 12.2522 23.1172C10.7087 24.0576 8.94239 22.2913 9.88285 20.7478C10.4904 19.7507 9.95193 18.4508 8.81731 18.1754C7.0609 17.749 7.0609 15.251 8.81731 14.8246C9.95193 14.5492 10.4904 13.2493 9.88285 12.2522C8.94239 10.7087 10.7087 8.94239 12.2522 9.88285C13.2493 10.4904 14.5492 9.95193 14.8246 8.81731Z",
    stroke: "#FBFDFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16.5C19.5 18.1569 18.1569 19.5 16.5 19.5C14.8431 19.5 13.5 18.1569 13.5 16.5C13.5 14.8431 14.8431 13.5 16.5 13.5C18.1569 13.5 19.5 14.8431 19.5 16.5Z",
    stroke: "#FBFDFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.42270f20655deecc1a1a4a26974b7ece.svg";
export { ForwardRef as ReactComponent };